<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <div class="container-fluid">

    <a class="navbar-brand" routerLink="/">
      <img class="logotar" src="/spotter-shared/assets/global-images/logos/{{site}}_logo.png">
      <img class="logotar" src="/spotter-shared/assets/global-images/logos/{{site}}_logo_text.png">
      @if (this.env.envName != 'prod') {
        <span class="badge bg-warning dev-mode-badge">{{env.envName}}</span>
      }

      @if (this.env.envName == 'prod' && window.location.hostname == 'localhost')
        {
        <span class="badge bg-danger">Your environment is not development!</span>
      }

    </a>

    <button class="navbar-toggler" type="button" (click)="mobileToggleClicked.emit()">
      <span class="navbar-toggler-icon"></span>
    </button>


    <div class="collapse navbar-collapse" id="navbarSupportedContent">

      <!-- This is a blank element so the avatar below is on the right hand side -->
      <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>

      <div class="">
        @if (!auth.tokenUser) {
          <span class="navbar-login-items">
            <a routerLink="login">{{'auth.links.login' | translate}}</a><span class="sep">|</span><a routerLink="register">{{'auth.links.register' | translate}}</a>
          </span>
        }
        @if (auth.tokenUser) {
          <span class="navbar-logged-items" ngbDropdown>
            <div class="username-area" ngbDropdownToggle>
              <div class="avatar">
                <img src="{{this.auth.tokenUser.profile_photo}}">
              </div>
              <div class="username">{{auth.tokenUser.name}}</div>
              <div ngbDropdownMenu class="dropdown-menu-end">
                <button ngbDropdownItem routerLink="/profile/dashboard">{{'auth.links.profile' | translate}}</button>
                <button ngbDropdownItem (click)="logout.emit();">{{'auth.links.logout' | translate}}</button>
                <!-- Custom items in the dropdown -->
                @if (navbarUserDropdownContent) {
                  <ng-container *ngTemplateOutlet="navbarUserDropdownContent"></ng-container>
                }
              </div>
            </div>
          </span>
        }
      </div>

    </div>
  </div>
</nav>